// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__18zs6","content":"Consent_content__dLKCJ","footer":"Consent_footer__25jX1"};